export const uk = {
    'new-package': 'Новый пакет'
};
